
/* TypeFase reusable photo previews */
(() => {
  if (window.TypeFasePhotoPreview) return;

  const urls = new WeakMap();

  function enhance(input) {
    if (input.dataset.tfPreviewReady === 'true') return;

    const scope = input.closest('[data-typefase-photo-preview]');
    if (!scope || input.type !== 'file') return;

    const holder =
      input.closest('.typefase-upload-field') ||
      input.parentElement;

    const label =
      (input.id &&
        scope.querySelector(
          'label[for="' + CSS.escape(input.id) + '"]'
        )) ||
      holder.querySelector('.typefase-editorial-upload');

    if (!label ||
        label.querySelector(
          '.typefase-upload-thumbnail, .tf-preview__image'
        )) return;

    input.dataset.tfPreviewReady = 'true';
    label.classList.add('tf-preview');

    const img = document.createElement('img');
    img.className = 'tf-preview__image';
    img.alt = 'Selected photo preview';
    img.hidden = true;

    const action = document.createElement('span');
    action.className = 'tf-preview__action';
    action.textContent = 'Replace Photo';
    action.hidden = true;

    label.append(img, action);

    function update() {
      const previous = urls.get(input);
      if (previous) URL.revokeObjectURL(previous);
      urls.delete(input);

      img.removeAttribute('src');

      const file = input.files && input.files[0];
      const isImage = file && (
        file.type.startsWith('image/') ||
        /\.(jpe?g|png|gif|webp|avif|heic)$/i.test(file.name)
      );

      img.hidden = !isImage;
      action.hidden = !file;
      label.classList.toggle(
        'tf-preview--selected', !!file
      );

      if (isImage) {
        const url = URL.createObjectURL(file);
        urls.set(input, url);
        img.src = url;
        img.onerror = () => {
          img.hidden = true;
        };
      }
    }

    input.addEventListener('change', update);
    update();
  }

  function scan(root = document) {
    root.querySelectorAll(
      '[data-typefase-photo-preview] input[type="file"]'
    ).forEach(enhance);
  }

  window.TypeFasePhotoPreview = { scan };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => scan(),
      { once: true }
    );
  } else {
    scan();
  }

  document.addEventListener(
    'shopify:section:load',
    e => scan(e.target)
  );

  const observer = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;

        if (node.matches?.('[data-typefase-photo-preview]')) {
          scan(node);
        } else if (
          node.querySelector?.('[data-typefase-photo-preview]')
        ) {
          scan(node);
        } else if (
          node.matches?.('input[type="file"]') &&
          node.closest('[data-typefase-photo-preview]')
        ) {
          enhance(node);
        }
      }
    }
  });

  const start = () => observer.observe(
    document.body,
    { childList: true, subtree: true }
  );

  if (document.body) {
    start();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  }
})();
